import { Paper, Textarea } from "@mantine/core";
import { receiptApi } from "apis/receiptApi";
import { Loading } from "components";
import { ErrorStatusType } from "constants/types/common";
import { useFormik } from "formik";
import { FC, useState } from "react";
import { useNotification } from "utils/hooks";

interface ReviewModalProps {
  journalId: string;
  action: "approve" | "reject";
  formId: string;
  onClose?: () => void;
  mutate?: () => void;
}

const ReviewModal: FC<ReviewModalProps> = ({
  journalId,
  action,
  formId,
  onClose,
  mutate,
}) => {
  const { notification } = useNotification();
  const [isLoading, setIsLoading] = useState(false);

  const formik = useFormik({
    initialValues: { reviewNote: "" },
    onSubmit: async (values) => {
      setIsLoading(true);
      try {
        const apiCall =
          action === "approve"
            ? receiptApi.approve(journalId, values)
            : receiptApi.reject(journalId, values);
        const res = await apiCall;
        if (res.data.success) {
          notification.success({
            title:
              action === "approve" ? "Xác nhận thành công" : "Từ chối thành công",
          });
          onClose?.();
          mutate?.();
          formik.resetForm();
        }
      } catch (error: ErrorStatusType | any) {
        notification.error({
          title:
            action === "approve" ? "Xác nhận thất bại" : "Từ chối thất bại",
          message: error?.error?.message,
        });
      }
      setIsLoading(false);
    },
  });

  return (
    <Loading variant="overlay" visible={isLoading}>
      <Paper>
        <form id={formId} onSubmit={formik.handleSubmit}>
          <Textarea
            label="Ghi chú xét duyệt"
            placeholder="Nhập ghi chú (tuỳ chọn)"
            value={formik.values.reviewNote}
            onChange={(e) => formik.setFieldValue("reviewNote", e.target.value)}
            rows={4}
          />
        </form>
      </Paper>
    </Loading>
  );
};

export default ReviewModal;
